module.exports = __webpack_public_path__ + "img/screens-multiple.679581d7.svg";